import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import ReactSelect from 'react-select';

const View = () => {

    const navigate = useNavigate();
    const { id } = useParams();
    const [urlParams, setUrlParams] = useSearchParams();
    const [serviceConsumer, setServiceConsumer] = useState({});
    const [isPaid, setIsPaid] = useState(true);
    const { readData: getServiceConsumer } = useEntityCrud('ServiceConsumer/GetServiceConsumer');

    const loc = useLocation();

    const { readData: GetAllGuilds } = useEntityCrud('Guild/GetAllGuilds');
    const [GuildFood, setGuildFood] = useState({});
    const [rowsDeliver, setRowsDeliver] = useState([]);

    const { readData } = useEntityCrud('Business/GetAllBusiness');
    const [businessId, setBusinessId] = useState(0);
    const { readData: getSingleBusiness } = useEntityCrud('Business/GetBusiness?BusinessId=' + businessId);
    const [paymentType, setPaymentType] = useState('debit');
    const [terminals, setTerminals] = useState([]);
    const [debitAmount, setDebitAmount] = useState('');
    const [cashAmount, setCashAmount] = useState('');
    const [debitPaid, setDebitPaid] = useState(false);
    const [cashPaid, setCashPaid] = useState(false);
    const [totalPaidAmount, setTotalPaidAmount] = useState(0);
    const [terminalNumber, setTerminalNumber] = useState('');
    const [serialNumber, setSerialNumber] = useState('');
    const [businesses, setBusinesses] = useState([]);
    const { addData: createPayment } = useEntityCrud('Payment/SetPayment');
    const [paymentId, setPaymentId] = useState(0);
    const { addData: getPayment } = useEntityCrud('Payment/GetPayment?id=' + paymentId);
    const { addData: changeStatus } = useEntityCrud('ServiceConsumer/changeServiceConsumer');
    const { addData: updateServiceConsumers } = useEntityCrud('ServiceConsumer/UpdateServiceConsumer');
    const { readData: searchDeliveries } = useEntityCrud('Business/getDeliverAgents');
    const [deliverId, setDeliverId] = useState(0);

    const [deliverPreparationTime, setDeliverPreparationTime] = useState('');
    let userDataBusinessId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')).businessId : {};



    useEffect(() => {

        readData().then(({ data }) => {
            if (data.status)
                setBusinesses(data.result);
        });

        const postedData = {
            serviceConsumerId: id,
            additionalInfo: []
        };
        if (urlParams.get('ipg'))
            postedData.ipg = 1;
        getServiceConsumer(postedData).then(({ data }) => {
            if (data.status) {
                let generatedServiceConsumer = {
                    ...data.result
                };
                let subServices = [];
                data.result.subServiceId.map(subService => {
                    if (subServices.findIndex(item => item.id == subService.id) >= 0)
                        subServices[subServices.findIndex(item => item.id == subService.id)].count += 1;
                    else
                        subServices.push({
                            id: subService.id,
                            title: subService.title,
                            price: subService.price,
                            count: 1
                        });
                    generatedServiceConsumer['subServices'] = subServices;
                    setIsPaid(generatedServiceConsumer.paymentResponseCode == '00');
                    setBusinessId(generatedServiceConsumer.businessId);
                })
                setServiceConsumer(generatedServiceConsumer);
            }
        });


        GetAllGuilds().then(({ data }) => {
            if (data.status)
                setGuildFood(data.result.find(item => item.id === 64));
        });

        const postedData2 = {
            "businessId": userDataBusinessId[0],
        }
        searchDeliveries(postedData2).then(({ data }) => {
            debugger
            if (data.status) {
                setRowsDeliver(data.result.filter(item => item.isActive === true).map(item => ({
                    value: item.id,
                    label: item.person.name + " " + item.person.lastName,
                    delivername: item.person.name,
                    deliverlastname: item.person.lastName,
                    delivermobile: item.person.cellphone,
                    delivervehicle: item.vehicleNo,
                })))
            }
            else {
                toast.error(data.message)
                setRowsDeliver({})
            }
        })

    }, [])

    useEffect(() => {
        if (businessId) {
            getSingleBusiness().then(({ data }) => {
                if (data.status) {
                    setTerminals(data.result.terminals || []);
                    if (data.result.terminals.length)
                        setTerminalNumber(data.result.terminals[0].terminalNo);
                }
            })
        }
    }, [businessId])

    useEffect(() => {
        if (totalPaidAmount == serviceConsumer.totalPay)
            setIsPaid(true);
    }, [totalPaidAmount])

    useEffect(() => {
        if (debitAmount <= serviceConsumer.totalPay)
            setCashAmount(serviceConsumer.totalPay - debitAmount);
        else {
            setDebitAmount(serviceConsumer.totalPay);
            setCashAmount('0');
        }
    }, [debitAmount])

    useEffect(() => {
        if (paymentId != 0) {
            let now = 60;
            let timer = setInterval(() => {
                now--;
                if (now == 0) {
                    clearInterval(timer);
                    getPayment().then(({ data }) => {
                        if (data.result.status && data.result.responseCode == '00')
                            toast.success('پرداخت شما با موفقیت در سیستم ثبت شد');
                        else
                            toast.warning('اطلاعات پرداخت شما یافت نشد');
                    })
                }
            }, 1000);
        }
    }, [paymentId])

    const submitPayment = () => {
        if (paymentType == 'cash') {
            const paymentPostedData = {
                serviceConsumerId: id,
                status: true,
                responseCode: '',//data.responseCode,
                amount: serviceConsumer.totalPay,
                hashedPan: '',
                terminalId: '',//data.data.terminalNumber,
                paymentType: 3,
                pan: '',//data.data.pan.toString().replace(/ /g,''),
                rrn: '',//data.data.rrn,
                traceNo: '',//data.data.traceNo
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setIsPaid(true);
                    setTotalPaidAmount(oldAmount => serviceConsumer.totalPay);
                    toast.success('پرداخت با موفقیت در سیستم ثبت شد')
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        } else {
            let timerInterval;
            Swal.fire({
                html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
                imageUrl: '/assets/images/payment-loader.svg',
                imageWidth: '60px',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 30 * 1000,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timer = 30;
                    timerInterval = setInterval(() => {
                        timer--;
                        if (b)
                            b.textContent = timer;
                    }, 1000)
                },
                timerProgressBar: true
            });
            const paymentPostedData = {
                serviceConsumerId: id,
                status: true,
                responseCode: '',
                amount: serviceConsumer.totalPay,
                hashedPan: '',
                paymentType: 1,
                terminalId: terminalNumber.toString(),
                pan: '',
                rrn: '',
                traceNo: ''
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setIsPaid(true);
                    setTotalPaidAmount(oldAmount => serviceConsumer.totalPay);
                    setPaymentId(data.result.id);
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        }
    }

    const submitDebitPayment = () => {
        let timerInterval;
        Swal.fire({
            html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
            imageUrl: '/assets/images/payment-loader.svg',
            imageWidth: '60px',
            showConfirmButton: false,
            allowOutsideClick: false,
            timer: 30 * 1000,
            didOpen: () => {
                const b = Swal.getHtmlContainer().querySelector('b');
                let timer = 30;
                timerInterval = setInterval(() => {
                    timer--;
                    if (b)
                        b.textContent = timer;
                }, 1000)
            },
            timerProgressBar: true
        });
        const paymentPostedData = {
            serviceConsumerId: id,
            status: true,
            responseCode: '',
            amount: debitAmount,
            hashedPan: '',
            paymentType: 1,
            terminalId: terminalNumber.toString(),
            pan: '',
            rrn: '',
            traceNo: ''
        };
        createPayment(paymentPostedData).then(({ data }) => {
            if (data.status) {
                setDebitPaid(true);
                setTotalPaidAmount(oldAmount => totalPaidAmount + debitAmount);
                setPaymentId(data.result.id);
            } else
                data.errors.map(error => toast.error(error.message));
        })
    }

    const submitCashPayment = () => {
        if (paymentType == 'debit-card') {
            let timerInterval;
            Swal.fire({
                html: 'در انتظار پرداخت <br style="margin-bottom: 10px"><b>30</b> ثانیه تا اتمام مهلت پرداخت',
                imageUrl: '/assets/images/payment-loader.svg',
                imageWidth: '60px',
                showConfirmButton: false,
                allowOutsideClick: false,
                timer: 30 * 1000,
                didOpen: () => {
                    const b = Swal.getHtmlContainer().querySelector('b');
                    let timer = 30;
                    timerInterval = setInterval(() => {
                        timer--;
                        if (b)
                            b.textContent = timer;
                    }, 1000)
                },
                timerProgressBar: true
            });
            const paymentPostedData = {
                serviceConsumerId: id,
                status: true,
                responseCode: '',
                amount: cashAmount,
                hashedPan: '',
                terminalId: terminalNumber.toString(),
                paymentType: 2,
                pan: '',
                rrn: '',
                traceNo: ''
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setCashPaid(true);
                    setTotalPaidAmount(oldAmount => totalPaidAmount + cashAmount);
                    setPaymentId(data.result.id);
                } else
                    data.errors.map(error => toast.error(error.message));
            })
        } else {
            const paymentPostedData = {
                serviceConsumerId: id,
                status: true,
                responseCode: '', //data.responseCode,
                amount: cashAmount,
                hashedPan: '',
                paymentType: 3,
                terminalId: '', //data.data.terminalNumber,
                pan: '', //data.data.pan.toString().replace(/ /g,''),
                rrn: '', //data.data.rrn,
                traceNo: '', //data.data.traceNo
            };
            createPayment(paymentPostedData).then(({ data }) => {
                if (data.status) {
                    setCashPaid(true);
                    setTotalPaidAmount(oldAmount => totalPaidAmount + cashAmount);
                    toast.success('پرداخت با موفقیت در سیستم ثبت شد')
                } else
                    data.errors.map(error => toast.error(error.message));
            }) 
        }
    }

    const handleBack = () => {
        debugger
        if (loc.pathname.includes("///")) {
            navigate('/', { replace: true });
        } else {
            navigate('/service-consumer', { replace: true });
        }

    }


    const handleStatusType = (consumerId, statusId) => {
        debugger
        const postedData2 = {
            "offset": 0,
            "limit": 10,
            "serviceConsumerId": consumerId,
            "status": statusId
        };

        changeStatus(postedData2).then(({ data }) => {
            debugger
            if (data.status) {
                if (statusId === 4) {
                }
                else {
                    toast.success(' وضعیت با موفقیت ثبت شد. ');
                    window.location.reload()
                }
            }
            else {
                toast.error(data.message);
            }
        })
    }


    const updateServiceConsuer = (consumerId, statusId) => {
        debugger
        const postedData = {
            "offset": 0,
            "limit": 10,
            "personId": 0,
            "registerDate": 0,
            "subServiceId": [
                0
            ],
            "serviceConsumerId": 0,
            "status": 0,
            "businessId": userDataBusinessId[0],
            "totalAmount": 0,
            "totalDiscount": 0,
            "totalPay": 0,
            "addressId": 0,
            "serviceConsumerId": consumerId,
            "delivername": deliverId.delivername,
            "deliverlastname": deliverId.deliverlastname,
            "delivermobile": deliverId.delivermobile,
            "delivervehicle": deliverId.delivervehicle,
            "deliverPreparationTime": deliverPreparationTime,
            "status": statusId,
            "additionalInfo": [
                {
                    "key": "",
                    "value": ""
                }
            ]
        };

        updateServiceConsumers(postedData).then(({ data }) => {
            debugger
            if (data.status) {
                toast.success('  اطلاعات با موفقیت ایجاد شد');
                navigate("/service-consumer");
            } else {
                toast.error(data.message);

            }
        })
    }


    return (
        <div className="card pt-4 pl-4">

            <div className="card-header d-flex justify-content-between">
                <div className="card-title">مشاهده خدمت / خدمات خریداری شده</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            {/*     {Object.keys(serviceConsumer).length ? <div className="card-body">
                <h5>اطلاعات کلی خدمت / خدمات خریداری شده</h5>
                <hr />
                <table className="table border text-nowrap text-md-nowrap table-bordered">
                    <thead>
                        <tr>
                            <th>خدمت گیرنده</th>
                            <th>کد ملی</th>
                            <th>استفاده کننده خدمت   </th>
                            <th>کد ملی استفاده کننده </th>
                            <th>  شماره همراه استفاده کننده </th>
                            <th>آدرس</th>
                            <th>کسب و کار</th>
                            <th>تاریخ</th>
                            <th>مبلغ کل</th>
                            <th>مبلغ تخفیف</th>
                            <th>مبلغ پرداخت شده</th>
                            <th>توضیحات</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{serviceConsumer.personFullName}</td>
                            <td>{serviceConsumer.nationalCode}</td>
                            <td>
                                {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                    if (serviceConsumer.additionalInfo[item].key === "firstName")
                                        return serviceConsumer.additionalInfo[item].value || "-"
                                })
                                )} &nbsp;
                                {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                    if (serviceConsumer.additionalInfo[item].key === "lastName")
                                        return serviceConsumer.additionalInfo[item].value || "-"
                                })
                                )}
                            </td>
                            <td>
                                {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                    if (serviceConsumer.additionalInfo[item].key === "nationalCode")
                                        return serviceConsumer.additionalInfo[item].value || "-"
                                })
                                )}
                            </td>
                            <td>
                                {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                    if (serviceConsumer.additionalInfo[item].key === "mobile")
                                        return serviceConsumer.additionalInfo[item].value || "-"
                                })
                                )}
                            </td>
                            <td>{serviceConsumer.customer_address}</td>
                            <td>{serviceConsumer.businessTitle}</td>
                            <td>{serviceConsumer.registerDate == null ? '-' : (serviceConsumer.registerDate.toString().slice(0, 4) + '-' + serviceConsumer.registerDate.toString().slice(4, 6) + '-' + serviceConsumer.registerDate.toString().slice(6, 8))}</td>
                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال</td>
                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalDiscount)} ریال</td>
                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال</td>
                            <td>{serviceConsumer.description}</td>
                        </tr>
                    </tbody>
                </table>
                <h5 className="mt-5">سرویس ها / خدمات</h5>
                <hr />
                <table className="table border text-nowrap text-md-nowrap table-bordered">
                    <thead>
                        <tr>
                            <th>ردیف</th>
                            <th>عنوان</th>
                            <th>قیمت</th>
                            <th>تعداد</th>
                            <th>قیمت کل</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceConsumer.subServices.map((subService, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{subService.title}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(subService.price)}</td>
                                <td>{subService.count}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(subService.price * subService.count)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {serviceConsumer.paymentResponseCode != '00' ?
                    <>
                        <h5 className="mt-5">  ثبت سفارش مجدد </h5>
                        <hr className="mb-3" />
                        {!isPaid ? <div>
                            <div className="row">
                                <div className="col-md-3 mb-3">
                                    <label>ترمینال</label>
                                    <select className='form-control' onChange={e => setTerminalNumber(e.target.value)}>
                                        <option>انتخاب کنید</option>
                                        {terminals.map(item => (
                                            <option value={item.terminalNo}>{item.terminalNo}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <h6 className="mb-4"><b>روش پرداخت</b></h6>
                            <label className="custom-control custom-radio">
                                <input type="radio" className="custom-control-input" name="payment-type" value="debit" checked onChange={e => setPaymentType(e.target.value)} />
                                <span className="custom-control-label">پرداخت یکجا (کارت کلوزلوپ یا کارت شتابی)</span>
                            </label>
                            <label className="custom-control custom-radio">
                                <input type="radio" className="custom-control-input" name="payment-type" value="cash" onChange={e => setPaymentType(e.target.value)} />
                                <span className="custom-control-label">پرداخت از طریق اسکناس به صورت نقدی</span>
                            </label>
                            <label className="custom-control custom-radio">
                                <input type="radio" className="custom-control-input" name="payment-type" value="debit-card" onChange={e => setPaymentType(e.target.value)} />
                                <span className="custom-control-label">پرداخت ترکیبی (کارت کلوزلوپ + کارت شتابی)</span>
                            </label>
                            <label className="custom-control custom-radio">
                                <input type="radio" className="custom-control-input" name="payment-type" value="debit-cash" onChange={e => setPaymentType(e.target.value)} />
                                <span className="custom-control-label">پرداخت ترکیبی (کارت کلوزلوپ + اسکناس به صورت نقدی)</span>
                            </label>
                            <label className="custom-control custom-radio mb-4">
                                <input type="radio" className="custom-control-input" name="payment-type" value="card-cash" onChange={e => setPaymentType(e.target.value)} />
                                <span className="custom-control-label">پرداخت ترکیبی (کارت شتابی + اسکناس به صورت نقدی)</span>
                            </label>
                            <hr />
                            {paymentType == 'debit' || paymentType == 'cash' ? <button className="btn btn-success" onClick={submitPayment}>پرداخت</button> :
                                <>
                                    {!debitPaid ? <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <input type="tel" className="form-control ltr-input" placeholder={paymentType.includes('debit') ? 'مبلغ پرداخت اعتباری' : 'مبلغ پرداخت شتابی'} onChange={e => setDebitAmount(e.target.value)} value={!debitAmount || debitAmount == 0 ? '' : debitAmount} />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <button className="btn btn-success btn-block" onClick={submitDebitPayment} disabled={debitAmount < 1}>پرداخت</button>
                                        </div>
                                    </div> : ''}
                                    {!cashPaid ? <div className="row">
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <input type="tel" className="form-control ltr-input" placeholder={paymentType.includes('debit') && !paymentType.includes('cash') ? 'مبلغ پرداخت شتابی' : 'مبلغ پرداخت نقدی'} readOnly value={!cashAmount || cashAmount == 0 ? '' : cashAmount} />
                                            </div>
                                        </div>
                                        <div className="col-md-1">
                                            <button className="btn btn-success btn-block" onClick={submitCashPayment} disabled={cashAmount < 1}>پرداخت</button>
                                        </div>
                                    </div> : ''}
                                </>
                            }
                        </div> : ''}
                    </>
                    : ''}
            </div> : <div className="card-body">
                <div className="alert alert-info">
                    <p>اطلاعاتی یافت نشد</p>
                </div>
            </div>}


 */}

            {Object.keys(serviceConsumer).length ? <div style={{ border: '2px solid #919090', margin: 20, borderRadius: 10 }}>

<div className="col-md-12">
    <div className="card mb-0" >
        <div className="row">
            <div className="col-md-6 p-4" style={{ borderLeft: '2px solid #919090' }} >
                <h5 className='pb-2'>
                    <b>
                        اطلاعات خریدار
                    </b>
                </h5>
                <p className="buyer-name">  نام : {serviceConsumer.personFullName}</p>
                <p className="business-title"> کد ملی : {serviceConsumer.nationalCode}</p>
                <p className="discount-amount" > تاریخ : <span dir="ltr">{serviceConsumer.registerDate ? (serviceConsumer.registerDate.toString().slice(0, 4) + '/' + serviceConsumer.registerDate.toString().slice(4, 6) + '/' + serviceConsumer.registerDate.toString().slice(6, 8)) : ''}</span></p>
                {serviceConsumer.customer_address ? <p className="total-amount">  آدرس : {serviceConsumer.customer_address}</p> : ''}
                <p className="total-amount">  توضیحات : {serviceConsumer.description || '-'}</p>


            </div>
            <div className="col-md-6   p-4">
                <p > وضعیت   :
                    <span
                        className={`${serviceConsumer.statusTitle === "منتظر تایید" ? "badge bg-warning px-4 py-1" :
                            serviceConsumer.statusTitle === "ثبت درخواست" ? "badge bg-secondary px-3  py-1" :
                                serviceConsumer.statusTitle === "لغو شده" ? "badge bg-danger px-3  py-1" :
                                    "badge bg-success px-3"}`}
                    >{serviceConsumer.statusTitle}
                    </span>
                </p>

                {serviceConsumer?.additionalInfo?.length > 0 ?
                    <>
                        <h5 className='mb-4 '>
                            <b>
                                اطلاعات استفاده کننده
                            </b>
                        </h5>

                        <p className="paid-amount">نام :
                            {(Object.keys(serviceConsumer?.additionalInfo)?.map((item, key) => {
                                if (serviceConsumer?.additionalInfo[item].key === "firstName")
                                    return serviceConsumer?.additionalInfo[item].value || "-"
                            })
                            )} &nbsp;
                            {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                if (serviceConsumer.additionalInfo[item].key === "lastName")
                                    return serviceConsumer.additionalInfo[item].value || "-"
                            })
                            )}</p>
                        <p className="payment-type">کد ملی :
                            {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                if (serviceConsumer.additionalInfo[item].key === "nationalCode")
                                    return serviceConsumer.additionalInfo[item].value || "-"
                            })
                            )}
                        </p>
                        <p className="card-number" dir="ltr">شماره همراه :
                            {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                if (serviceConsumer.additionalInfo[item].key === "mobile")
                                    return serviceConsumer.additionalInfo[item].value || "-"
                            })
                            )}
                        </p>
                        <p className="card-number" dir="ltr">شماره بیمه :
                            {(Object.keys(serviceConsumer.additionalInfo)?.map((item, key) => {
                                if (serviceConsumer.additionalInfo[item].key === "insuranceNo")
                                    return serviceConsumer.additionalInfo[item].value || "-"
                            })
                            )}
                        </p>
                    </> : <>
                        <h5 className='mb-4 '>
                            <b>
                                اطلاعات استفاده کننده
                            </b>
                        </h5>
                        <p className="paid-amount">نام : {serviceConsumer.personFullName}</p>
                        <p className="paid-amount">کد ملی : {serviceConsumer.nationalCode}</p>
                    </>
                }

            </div>
        </div>

        <div className="row">
            <div className="col-md-12 py-4 " style={{ borderTop: '2px solid #919090', borderBottom: '2px solid #919090' }}>
                <h5 className='mb-4'>
                    <b>
                        محصول
                    </b>
                </h5>
                <table className="table border text-nowrap text-md-nowrap table-bordered">
                    <thead>
                        <tr>
                            <th className='py-1'>عنوان</th>
                            <th className='py-1'>قیمت</th>
                            <th className='py-1'>تعداد</th>
                            <th className='py-1'>قیمت کل</th>
                        </tr>
                    </thead>
                    <tbody>
                        {serviceConsumer?.subServices?.map((subService, index) => (
                            <tr key={index}>
                                <td>{subService.title}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(subService.price)}</td>
                                <td>{subService.count}</td>
                                <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(subService.price * subService.count)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>


        <div className="row">
            <div className="col-md-6  p-4" style={{ borderLeft: '2px solid #919090' }}>
                <h5>
                    <b>
                        پرداخت
                    </b>
                </h5>

                <p className="buyer-name">   روش پرداخت : {serviceConsumer.payment_Type || '-'} </p>
                <p className="buyer-name">  مبلغ کل : {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال </p>
                <p className="total-amount">  مبلغ پرداخت شده	 :  {new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(serviceConsumer.totalPay)} ریال
                </p>


            </div>
            <div className="col-md-6  p-4">

                {serviceConsumer.status !== 5 ?
                    <>
                        <div className="operation-btn-group d-flex justify-content-between">
                            <div className='d-flex align-items-center'>

                                {/*                                             {item.statuses.statuses.filter(s => s.id !== 6).filter(d => d.id > item.status).sort((a, b) => a.id - b.id).map(it => (
*/}
                                <>

                                    {serviceConsumer.status === 1 && <button onClick={() => handleStatusType(serviceConsumer.serviceConsumerId, 2)}
                                        title="منتظر تایید"
                                        className="btn btn-icon me-1 mb-0 btn-warning">
                                        <i className="fa fa-hourglass-start"></i>
                                    </button>}

                                    {serviceConsumer.status === 2 || serviceConsumer.status === 7 ? <button
                                        onClick={() => handleStatusType(serviceConsumer.serviceConsumerId, serviceConsumer.status === 2 ? 3 : 8)}
                                        title={serviceConsumer.status === 2 ? 'تایید شده و در حال آماده سازی' : 'تایید شده و در حال برگزاری'}
                                        className="btn me-1 mb-0 btn-success">
                                        تایید
                                    </button> : ''}

                                    {serviceConsumer.status === 3 && <button
                                        onClick={() => handleStatusType(serviceConsumer.serviceConsumerId, 4)}
                                        data-bs-toggle="collapse"
                                        href={`#collapseFour0${serviceConsumer.serviceConsumerId}`}
                                        data-bs-parent="#accordion"
                                        aria-expanded="false"
                                        title="ارسال شده"
                                        className="btn me-1 mb-0 btn-secondary">
                                        ارسال شده
                                    </button>}

                                    {serviceConsumer.status === 4 || serviceConsumer.status === 8 ? <button onClick={() => handleStatusType(serviceConsumer.serviceConsumerId, serviceConsumer.status === 4 ? 5 : 9)}
                                        title={serviceConsumer.status === 4  ? 'تحویل شده' : 'پایان یافته'}
                                        className="btn me-1 mb-0 btn-primary">
                                        تحویل شده
                                    </button> : ''}

                                    {serviceConsumer.status === 2 || serviceConsumer.status === 7 || serviceConsumer.status === 8 || serviceConsumer.status === 9 ? <button onClick={() => handleStatusType(serviceConsumer.serviceConsumerId, serviceConsumer.status === 2 ? 6 : 10)}
                                        title="لغو شده"
                                        className="btn me-1 mb-0 btn-danger">
                                        عدم تایید
                                    </button> : ''}

                                    {/*                                         
                                      <button onClick={() => handleStatusType(item.serviceConsumerId, it.id)}
                                        title={it.title}
                                        data-bs-toggle="collapse"
                                        href={`#collapseFour0${item.serviceConsumerId}`}
                                        data-bs-parent="#accordion"
                                        aria-expanded="false"

                                        className={`accordion-toggle collapsed  btn btn-icon me-1 mb-0 ${it.id === 1 ? "btn-info" :
                                            it.id === 2 ? "btn-warning" :
                                                it.id === 3 ? "btn-success" :
                                                    it.id === 4 ? "btn-secondary" :
                                                        it.id === 5 ? "btn-primary" : ""}`}>

                                        <i className={`fa ${it.id === 1 ? "fa-sticky-note-o" :
                                            it.id === 2 ? "fa-hourglass-start" :
                                                it.id === 3 ? "fa-check" :
                                                    it.id === 4 ? "fa-motorcycle" :
                                                        it.id === 5 ? "fa-hand-grab-o" : ""}`}></i>
                                    </button> */}
                                </>




                            </div>


                        </div >
                        <div className="panel-group1" >
                            <div id={`collapseFour0${serviceConsumer.serviceConsumerId}`}
                                className="panel-collapse collapse position-relative"
                                role="tabpanel"
                                aria-expanded="false">


                                <div className="row py-4 d-flex align-items-center" style={{ textAlign: "right" }}>
                                    <div className="col-md-5">
                                        <div className="form-group">
                                            <ReactSelect label=" پیک "
                                                options={rowsDeliver}
                                                value={deliverId}
                                                onChange={(value) => setDeliverId(value)}
                                                placeholder="  پیک مورد نظر را انتخاب کنید  :"
                                                name="deliverId"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group">
                                            <input type="number" min={0} maxLength={4}
                                                placeholder='مدت زمان تحویل'
                                                className="form-control" value={deliverPreparationTime}
                                                onChange={e => setDeliverPreparationTime(e.target.value)} />
                                        </div>
                                    </div>
                                    <button className="col-md-2 btn btn-success mb-4 mt-0 btn-block btn-without-label"
                                        onClick={() => updateServiceConsuer(serviceConsumer.serviceConsumerId, 4)} > ثبت پیک </button>
                                </div>

                            </div>
                        </div>
                    </>
                    : " وضعیت قابل تغییر نمی باشد."}

            </div>

        </div>






    </div>
</div>
</div> : <p className="text-center py-4">در حال بارگذاری ...</p>}
            
        </div>
    );
}

export default View;